import axios from "axios";
import configuration from "../configuration/configuration";

/**
 * Téléphonie OVH : état, click2call et journal des appels (routes /api/telephonie de l'API).
 * Les erreurs sont renvoyées telles quelles : le message du serveur est dans error.response.data.message.
 */
export default class TelephonieAPI {

    async request(method, url, data) {
        const response = await axios({
            method: method,
            url: `${configuration.API}/api/${url}`,
            headers: {'content-type': 'application/json'},
            data: data
        });

        return response.data;
    }

    getEtat() {
        return this.request('get', 'telephonie/etat');
    }

    appeler(numero) {
        return this.request('post', 'telephonie/appeler', {numero});
    }

    getAppels(page, limit, statut, aTraiter) {
        return this.request('get', `telephonie/appels?page=${page}&limit=${limit}&statut=${statut || ""}&a_traiter=${aTraiter ? 1 : 0}`);
    }

    traiter(id) {
        return this.request('post', `telephonie/appels/${id}/traiter`);
    }
}
